import LocalizedStrings from 'react-localization';

import en from './english/en.js'

export const localizedStrings = new LocalizedStrings({en});
